import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { SharedModule } from '../../../../shared/shared.module';
import { AdministratorService } from '../../../../services/administrator.service';

@Component({
  selector: 'app-create-payment-terms',
  standalone: true,
  imports: [SharedModule, CommonModule],
  providers:[MessageService],
  templateUrl: './create-payment-terms.component.html',
  styleUrl: './create-payment-terms.component.scss'
})
export class CreatePaymentTermsComponent {

  constructor(private messageService: MessageService , private router:Router, private routers: ActivatedRoute, private paymentTermsService:AdministratorService) { }

  submitted: boolean = false;
  isEditMode: boolean = false;
  paymentTermsId: number | undefined;
 

  
  createPaymentTermsForm = new FormGroup({
    termsCode: new FormControl('', Validators.required),
    discount: new FormControl('', Validators.required),
    conditionalDiscount: new FormControl('', Validators.required),
    netDue: new FormControl('', Validators.required),
    paymentTermsDescription: new FormControl('', Validators.required),
    // CheckBox
    isActive: new FormControl(true,Validators.requiredTrue),
    createdBy: new FormControl(),
  });

  
  ngOnInit(): void {
  document.title = 'Create Payment Term';
  this.getit();
  this.createPaymentTermsForm.controls.createdBy.setValue(localStorage.getItem('username'));
  }
 

  getit(){
    this.routers.queryParams.subscribe(params => {
      this.paymentTermsId = params['paymentTermsId'];
      this.isEditMode = !!this.paymentTermsId;
      document.title = 'Update Payment Term';
      if (this.isEditMode) {
        // If in edit mode, fetch the salesperson details
        this.paymentTermsService.getPaymentTermsId(this.paymentTermsId).subscribe(
          ( unitOfMeasure: any) => {
            if (unitOfMeasure) {
              this.createPaymentTermsForm.patchValue(unitOfMeasure);
            } else {
              console.error('Payment terms data not found.');
            }
          },
          (error: any) => {
            console.error('Error fetching payment terms data:', error);
            console.error(error);
          }
        );
      }else{
        this.resetForm();
      }
    });
  }
  resetForm() {
    this.createPaymentTermsForm.reset();
    this.createPaymentTermsForm.controls.isActive.setValue(true);
  }


  get formControls() {
    return this.createPaymentTermsForm.controls;
  }

  validateForm() {
    let isValid = true;
    if (this.createPaymentTermsForm.invalid) {
      this.messageService.add({ severity: 'warn', summary: 'Warning', detail: 'Please fill Required field' })
      isValid = false;
    }

    return isValid;
  }

 savePaymentTerms(data: any, isEditMode: boolean) {
  this.submitted = true;
  const isValid = this.validateForm();
  if (!isValid) {
    return;
  }
  data.conditionalDiscount = data.conditionalDiscount.toString();
  data.netDue = data.netDue.toString();
  if (isEditMode) {
    this.updatePaymentTerms(data); 
  } else {
    this.createPaymentTerms(data);
  }
}

updatePaymentTerms(data: any) { 
  this.submitted = true;
  const isValid = this.validateForm();
  if(!isValid) {
    return;
  }
  let updatedBy = localStorage.getItem('username');
  const updatedData = {
    paymentTermsId: this.paymentTermsId,
    termsCode: data.termsCode,
    discount: data.discount,
    conditionalDiscount: data.conditionalDiscount,
    netDue: data.netDue,
    paymentTermsDescription: data.paymentTermsDescription,
    isActive: data.isActive,
    UpdatedBy: updatedBy,
  };

  if (updatedData) {
    this.paymentTermsService.updatePaymentTerms(updatedData).subscribe({
      next: () => {
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Payment terms Updated Successfully.' });
        setTimeout(() => {
          this.router.navigate(['/home/paymentTermList']); 
        }, 1000);
      },
      error: error => {
        console.error('Error updating payment terms:', error);
      }
    });
  }
}
  

  createPaymentTerms(data: any){
    this.submitted = true;
    const isValid = this.validateForm();
    if(!isValid) {
      return;
    }
    this.paymentTermsService.createPaymentTerms(data).subscribe({
      next: (data: any) => {
        if(data.success){
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Payment terms Created Successfully.' })
          setTimeout(() => {
            this.router.navigate(['/home/paymentTermList']);
          }, 1000);
        }else{
          this.messageService.add({ severity: 'error', summary: 'Failed', detail: data.message });
        }
      },
      error: error => {
  
      }
    })
  
  }

  Cancel(){
    this.router.navigate(['/home/paymentTermList']);
  }
  onKeydown(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      this.moveToNextField(event);
    }
  }

  moveToNextField(event: KeyboardEvent) {
    const inputs = Array.from(document.querySelectorAll('input')) as HTMLInputElement[];
    const index = inputs.indexOf(event.target as HTMLInputElement);
    if (index > -1 && index < inputs.length - 1) {
      (inputs[index + 1] as HTMLInputElement).focus();
    }
  }
}
